const ArrowDownSVG = () => {
    return (
        <svg
            viewBox="402.905 222.653 198.737 55.359"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g transform="matrix(1, 0, 0, 1, -282.0712645227908, -1537.888216185847)">
                <path
                    fill="#000000FF"
                    d="M 691.8 1760.8 C 691.8 1760.8 695.0 1761.8 696.6 1762.2 C 699.2 1763.0 701.6 1764.2 704.1 1765.3 C 710.1 1767.9 716.1 1770.6 722.0 1773.4 C 728.0 1776.3 733.0 1781.0 738.5 1784.8 C 750.2 1792.9 761.8 1800.7 773.7 1808.7 C 773.9 1808.8 780.6 1805.8 784.2 1804.8 C 794.9 1801.6 805.7 1798.4 816.5 1795.2 C 827.5 1791.9 839.1 1790.8 850.3 1788.7 C 856.0 1787.7 862.1 1786.8 867.8 1785.4 C 869.2 1785.0 878.4 1782.3 878.4 1782.8 C 878.4 1783.9 880.6 1782.0 881.7 1782.3 C 883.9 1782.9 884.2 1785.6 882.8 1787.0 C 882.6 1787.3 882.6 1787.3 882.6 1787.3 C 882.6 1787.3 880.0 1789.3 878.7 1790.3 C 876.9 1791.7 873.0 1794.1 872.3 1790.5 C 872.2 1790.2 868.3 1791.4 866.3 1791.7 C 861.6 1792.6 856.9 1793.5 852.2 1794.3 C 842.5 1796.1 832.8 1797.9 823.2 1799.6 C 810.5 1802.0 798.1 1806.0 786.0 1810.3 C 782.9 1811.4 777.1 1815.7 773.0 1815.0 C 763.2 1813.4 756.2 1804.2 747.9 1798.6 C 729.4 1786.1 711.7 1772.1 689.8 1766.1 C 689.5 1766.0 685.7 1766.2 685.6 1764.8 C 685.4 1761.4 688.7 1761.4 691.2 1760.8 M 691.2 1760.7 C 691.2 1760.7 691.4 1760.7 691.5 1760.7 "
                ></path>
            </g>
        </svg>
    );
};

export default ArrowDownSVG;
